import { useMutation } from '@apollo/client'
import { AddPriceVariables, AddPrice } from '../../types'
import { ADD_COMPANY_PRICE } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useAddCompanyPrice = ({ onCompleted }: Props) =>
  useMutation<AddPrice, AddPriceVariables>(ADD_COMPANY_PRICE, { onCompleted })
